/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Popper } from "@mui/material";
import clsx from "clsx";
import useClasses from "../common/useClasses";

const useStyles = (() => ({
  root: {
    width: "100%",
  },
  popperStyle: {
    // left: "150px !important",
    "& .MuiAutocomplete-listbox": {
      padding: 0,
    },
    zIndex: 9999999,
  },
  AccordionSummary: {
    background: "#e5e5e5",
    marginBottom: "10px",
    minHeight: "45px !important",
    height: "45px",
  },
  MuiAutocompletelistboxSIInner: {
    padding: 0,
  },
  Autocomplete: {},
}));

export default function SingleSelectDropdown(props: any) {  
const classes = useClasses(useStyles);
  return (
    <div className="exp-search-input">
      <Autocomplete
        className={classes.Autocomplete}
        title={props?.addionalConfig?.title}
        onFocus={(event: any) => {
          props.onFocus && props.onFocus(event);
        }}
        style={{ width: props?.addionalConfig?.width }}
        freeSolo
        id="free-solo-2-demo"
        // open={true}
        disableClearable
        options={props.data && props.data.length > 0 ? props.data : []}
        getOptionLabel={(option: any) => option?.label}
        groupBy={(option: any) => option?.Type}
        onChange={(event: any, newValue: any | null) => {
          event.preventDefault();
          props.onChange(newValue);
        }}
        inputValue={props?.inputValue}
        onInputChange={(event, newInputValue: any, reason) => {
          reason == "input" && props.onInputChange(newInputValue);
        }}
        PopperComponent={(popperRef: any) => {
          return (
            <div>
              <Popper
                {...popperRef}
                className={clsx(classes.popperStyle,'search-input-popper-style-custom')}
                style={{ width: props?.addionalConfig?.popperWidth ? props.addionalConfig.popperWidth : 700 }}
              >
                {" "}
                {popperRef.children}{" "}
              </Popper>
            </div>
          );
        }}
        renderGroup={(item) => {
          if (props?.addionalConfig?.renderGroupWithAccordion) {
            return (
              <div className={classes.root}>
                <Accordion
                  TransitionProps={{ timeout: { appear: 1, enter: 1, exit: 4 } }}
                  defaultExpanded={props?.addionalConfig?.defaultExpanded}
                >
                  <AccordionSummary
                    className={classes.AccordionSummary}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>{item.group}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ul
                      className={clsx(
                        classes.MuiAutocompletelistboxSIInner,
                        "MuiAutocomplete-listbox-SI-inner"
                      )}
                    >
                      {item.children}
                    </ul>
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          } else {
            return item.children;
          }
        }}
        renderInput={(params: any) => (
          <TextField
            {...params}
            placeholder={props?.addionalConfig?.placeholder}
            label=""
            // name='test'
            // margin="normal"
            variant="outlined"
            size={props?.addionalConfig?.size}
            InputProps={{ ...params.InputProps, type: "search" }}
          />
        )}
      />
    </div>
  );
}
